/* ============================================================================
   custom-variant-picker.js
   ----------------------------------------------------------------------------
   Pilotage d’un picker Shopify masqué via des cartes « variant-card ».
   - Met à jour l’ID de variante dans <input name="id"> (champ caché du form)
   - Déclenche les événements ‘change’ attendus par Dawn / scripts tiers
   - Met à jour les prix affichés et l’état visuel des cartes
   ========================================================================== */
document.addEventListener('DOMContentLoaded', () => {
  /* ---------- Sélection des éléments indispensables ---------- */
  const container = document.querySelector('.custom-variant-cards');
  if (!container) return;                       // Cartes absentes ⇒ on sort

  const form = document.querySelector('form[action*="/cart/add"]');
  if (!form) return;                            // Formulaire introuvable

  const variantIdInput = form.querySelector('input[name="id"]');
  if (!variantIdInput) return;                  // Champ caché introuvable

  /* Sélecteurs alternatifs pour l’affichage du prix (ajustez selon votre thème) */
  const mainPriceElement   = document.querySelector(
    '#price-container .bold.regularsize, \
     .product__info_wrapper .price__regular, \
     .product-form__price .price__regular, \
     .price--actual'
  );
  const comparePriceElement = document.querySelector(
    '#price-container .bold.smallersize, \
     .product__info_wrapper .price__compare, \
     .product-form__price .price__compare, \
     .price--compare'
  );

  const cards = container.querySelectorAll('.variant-card');

  /* ---------- Comportement au clic sur une carte ---------- */
  cards.forEach(card => {
    const isSoldOut = card.classList.contains('sold-out');
    if (isSoldOut) return;                      // Carte épuisée ⇒ pas de clic

    card.addEventListener('click', () => {
      /* Données extraites des data-attributes de la carte */
      const { variantId, price, compare, available } = card.dataset;
      if (available === 'false') return;

      /* --- 1. Mise à jour VISUELLE des cartes --- */
      cards.forEach(c => {
        c.classList.remove('active');
        c.setAttribute('aria-pressed', 'false');
      });
      card.classList.add('active');
      card.setAttribute('aria-pressed', 'true');

      /* --- 2. Coche le radio natif s’il existe (optionnel) --- */
      const nativeRadio = document.querySelector(`[data-variant-id="${variantId}"]`);
      if (nativeRadio) {
        nativeRadio.checked = true;
        nativeRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }

      /* --- 3. ÉCRASE systématiquement le champ caché name="id" --- */
      variantIdInput.value = variantId;
      variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
      /* Certains thèmes écoutent aussi le formulaire → on propage */
      form.dispatchEvent(new Event('change', { bubbles: true }));

      /* --- 4. Mise à jour des PRIX affichés (si éléments présents) --- */
      if (mainPriceElement)   mainPriceElement.textContent = price || '';
      if (comparePriceElement) {
        if (compare && compare !== price) {
          comparePriceElement.textContent = compare;
          comparePriceElement.style.display = 'inline-block';
        } else {
          comparePriceElement.style.display = 'none';
        }
      }
    });
  });

  /* ---------- État initial : carte correspondant à l’ID pré-coché ---------- */
  const initialId = variantIdInput.value;
  cards.forEach(card => {
    if (card.dataset.variantId === initialId) {
      card.classList.add('active');
      card.setAttribute('aria-pressed', 'true');
    } else {
      card.classList.remove('active');
      card.setAttribute('aria-pressed', 'false');
    }
  });
});